import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ThankYouBannerComponent } from '../shared/thank-you-banner/thank-you-banner.component';
import { ErrorModalHelperService } from '../_helpers/error-modal-helper/error-modal-helper.service';
import { ThemeService } from '../_helpers/theming-engine/theme.service';
import { CheckStudentFeedbackResponse } from '../_models/student-feedback/check-student-feedback-response.model';
import { UserFeedbackListing } from '../_models/student-feedback/user-feedback-listing.model';
import { AuthenticationService } from '../_services';
import { StudentFeedbackService } from '../_services/student-feedback/student-feedback.service';

@Component({
    selector: 'student-voice',
    templateUrl: './student-voice.component.html',
    styleUrls: ['./student-voice.component.css'],
    standalone: false
})
export class StudentVoiceComponent implements OnInit {

  public studentHasNeverCompletedSurveys: boolean = true;
  public feedbackListings: Array<UserFeedbackListing> = new Array<UserFeedbackListing>();

  private studentId: number;

  constructor(
    private feedbackService: StudentFeedbackService,
    private errorModalHelper: ErrorModalHelperService,
    public themeService: ThemeService,
    private authService: AuthenticationService
    ) { }

  ngOnInit() {
    this.studentId = this.authService.userSessionData.currentUser.id;
    this.getFeedback();
  }

  public toggleBar(surveyContainer: Element, feedbackListing: UserFeedbackListing): void {
    if (!surveyContainer.classList.contains("hide-survey")) {
      // transitioning to hidden
      surveyContainer.classList.add("hide-survey");
      setTimeout(() => {
        surveyContainer.classList.add("d-none");
        feedbackListing.expanded = false;
      }, 400);
    } else {
      // transitioning to show
      surveyContainer.classList.remove("d-none");
      setTimeout(() => {
        surveyContainer.classList.remove("hide-survey");
        feedbackListing.expanded = true;
      }, 0);
    }
  }

  public feedbackSubmitted(submitted: boolean): void {
    if (submitted) {
      this.getFeedback();
    }
  }

  private getFeedback(): void {
    this.feedbackService.checkUserFeedbackSurveys(this.studentId).subscribe((result: CheckStudentFeedbackResponse) => {
      this.feedbackListings = result.feedbackSurvey;
      this.studentHasNeverCompletedSurveys = result.studentHasNeverCompletedSurveys;

      if (result.feedbackSurvey && result.feedbackSurvey.length > 0) {
        this.feedbackListings[0].expanded = true;
      }
    },
    error => {
      this.errorModalHelper.show(error.message, error);
    });
  }

}
